import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { OrderData } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { DataService } from '../data/data.service';

@Injectable({
  providedIn: 'root',
})
export class TradingService {
  readonly #http = inject(HttpClient);
  readonly #rootDataService = inject(DataService);

  public cancelOrder(order: OrderData) {
    return this.#http.post<{ status: string }>(`${environment.apihost + environment.tradingServiceUrl}/order/cancel`, {
      customer: this.#rootDataService.getSelectedCustomer(),
      orderId: order.orderId,
    });
  }
}
